import React, { useMemo } from 'react';
import { Menu } from 'antd';
import type { ItemType } from 'antd/es/menu/interface';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { isHasAccess } from 'features/validateAccess';
import { ReactComponent as ArrowIcon } from 'shared/assets/icons/dynamicColor/arrow-bottom.svg';
import { navItems } from '../../config/navItems';

import styles from './MainNav.module.scss';

const MainNav: React.FC<{ inDrawer?: boolean }> = ({ inDrawer = false }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const filteredNavItems = useMemo(
    () =>
      navItems
        .filter((item) => isHasAccess(item.requiredPermissions))
        .map((item) =>
          item.children
            ? { ...item, children: item.children?.filter((child) => isHasAccess(child.requiredPermissions)) }
            : item,
        ),
    [],
  );

  const menuItems: ItemType[] = useMemo(
    () =>
      filteredNavItems.map((item) => {
        if (item.children) {
          return {
            key: item.id,
            label: t(item.captionID),
            popupOffset: [-13, 8],
            icon: !inDrawer && <ArrowIcon />,
            children: item.children.map((child) => ({
              key: child.path,
              label: <Link to={child.path}>{t(child.captionID)}</Link>,
            })),
          };
        }
        return {
          key: item.path,
          label: <Link to={item.path}>{t(item.captionID)}</Link>,
        };
      }),
    [filteredNavItems, t, inDrawer],
  );

  return (
    <Menu
      mode={inDrawer ? 'inline' : 'horizontal'}
      data-mode={inDrawer ? 'inline' : 'horizontal'}
      selectedKeys={[pathname]}
      className={styles.container}
      items={menuItems}
    />
  );
};

export default MainNav;
